import * as React from "react";
import { TaskModel, WorkQueueClient, WorkQueueItemDetailModel, WorkQueueItemModel, WorkQueueJobModel } from "@app/api2/api";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";
import { BPColumn } from "@common/BPReactTable";
import { toLocalTime } from "@common/Utils";
import { refreshInterval } from "./WorkQueue";
import { downloadBlob } from '@common/Utils';
import { Link } from "react-router-dom";
import { BPButton } from "@/components/bp/bpbutton";


export interface IWorkQueueItemProps {
    workersEnabled: boolean;
    data?: WorkQueueItemModel;
}

export class WorkQueueItemState {
    public item: WorkQueueItemDetailModel;
    public tasks: TaskModel[];
}

export class WorkQueueItem extends React.Component<IWorkQueueItemProps, WorkQueueItemState> {
    private workQueueClient = new WorkQueueClient();
    timer: any = null;
    constructor(props, context) {
        super(props, context);
        this.state = new WorkQueueItemState();
    }

    public async componentDidMount(): Promise<any> {
        this.timer = setInterval(() => {
            if (this.timer != null)
                this.loadData();
        }, refreshInterval);

        await this.loadData();
    }

    componentWillUnmount() {
        if (this.timer != null) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    private async loadData() {
        const result = await this.workQueueClient.detail(this.props.data.id);

        this.setState({
            item: result,
            tasks: []
        });

        const workersEnabled = await this.props.workersEnabled;

        if (workersEnabled) {
            const workers = await this.workQueueClient.getWorkers();

            this.setState({
                tasks: [...workers.activeTasks, ...workers.reserverdTasks]
            });
        }
    }

    public async revoke(taskId: string) {
        await this.workQueueClient.revokeTask(taskId);
        await this.loadData();
    }

    public render() {
        const columns: BPColumn<WorkQueueJobModel>[] = [
            {
                Header: window.translation.caseRun.step,
                accessor: 'phase',
                Cell: (cell) => <>{cell.value ? window.translation.jobPhase[cell.value] : '_empty_'}</>,
            }, {
                Cell: (cell) => <>{toLocalTime(cell.value)}</>,
                Header: window.translation.common.created,
                accessor: "started",
            }, {
                Cell: (cell) => <>{toLocalTime(cell.value)}</>,
                Header: window.translation.common.completed,
                accessor: "completed",
            }, {
                Cell: (cell) => {
                    const task = this.state.tasks.find(t => t.bpJobId.toLowerCase() == this.props.data.id.toLowerCase() && t.phase == cell.row.original.phase);
                    if (task) {
                        return <BPButton negative onClick={() => this.revoke(task.taskId)}>{window.translation.common.delete}</BPButton>;
                    } else {
                        return <span></span>;
                    }
                },
                Header: "",
                id: "btn",
            },
            {
                Cell: (cell) => {
                    return <>
                        {/* <a download={'stdout.log'} href={`data:plain/text;base64,${btoa(cell.row.original.stdOut ?? '')}`}>Download log</a> */}
                        <BPButton as={Link} onClick={() => downloadBlob({ data: new Blob([cell.row.original.stdOut], { type: 'plain/text' }), fileName: 'stdout.log' })}>{'Download Calculation Logs'}</BPButton>
                    </>
                },
                Header: "",
                id: "btn2",
            }
        ];
        if (this.state.item) {
            return (<div style={{ padding: "10px" }}>
                <BPDataTable3
                    simple
                    dataSource={p => Promise.resolve({ items: this.state.item.jobs, totalRows: 0 })}
                    columns={columns} />
            </div>);
        } else {
            return (<div style={{ padding: "10px" }}>

            </div>);
        }
    }
}
